import React, { useState, useEffect } from "react";

import { IoEllipsisVerticalSharp } from "react-icons/io5";
import { experimentalStyled as styled } from "@mui/material/styles";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

import VuiBox from "components/VuiBox";
import VuiLabel from "components/VuiLabel";
import VuiButtonCustom from "components/VuiButtonCustom";
import Table from "examples/Tables/Table";

import colors from "assets/theme/base/colors";

import moment from "moment";

export function InfoUserLogs({ item, onClose }) {
  console.log(">>> InfoUserLogs:item", item);
  const [columns, setColumns] = useState([]);

  // users:  {
  //   id: 23571,
  //   createdAt: '2025-11-24 09:50:52',
  //   username: 'sergianny.silva',
  //   status: 9,
  //   urlSentSupport: null,
  //   urlSentCoorp: null,
  //   remoteAddress: '0.0.0.0',
  //   ipClient: '10.34.1.238',
  //   macAddress: '64:1C:67:ED:88:4D',
  //   xIpForwarded: '0.0.0.0',
  //   userAgent: 'Agent - W2K - logon.vbs',
  //   logText: '24/11/2025 - 09:50:52, LOGON ACTIVE, sergianny.silva, , NT-ASSJUR-01, [GABINETE_ASSGAB_GAB][GABINETE_ASSGAB_ASSJUR], (10.34.1.238 - Realtek PCIe GbE Family Controller),'
  // },

  useEffect(() => {
    setColumns([
      { label: "Data de Logon", name: "createdAt", align: "left" },
      { label: "Usuário", name: "username", align: "center" },
      { label: "IP Address", name: "ipClient", align: "center" },
      { label: "Mac Address", name: "macAddress", align: "center" },
    ]);
  }, [false]);

  return (
    <VuiBox
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "50%",
        bgcolor: colors.grey[600],
        border: "1px solid #000",
        boxShadow: 24,
        borderRadius: 2,
        p: 2,
      }}
      onClick={() => {
        onClose;
      }}
    >
      {item && (
        <>
          <VuiLabel title="Evento de LOGON" fontWeightTitle={"bold"} sizeTitle={16} />

          <Grid container spacing="0px" sx={{ fontSize: 14, color: "#fff" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: 0,
                width: "100%",
                marginBottom: 15,
                color: "#fff",
              }}
            >
              <Table columns={columns} rows={item} />
            </div>

            {/* {item.map((x) => {
              console.log(
                "",
                x.id,
                // x.createdAt,
                // x.username,
                // x.ipClient,
                // x.macAddress,
                x.logText.split("JSON ").length > 1
                  ? JSON.parse(x.logText.split("JSON ")[1])
                  : x.logText.split("JSON ")[0]
              );
              return (
                <>
                  <Grid item xs={12} lg={6} xl={3}>
                    <span style={{ fontSize: 14 }}>{x.createdAt}</span>
                  </Grid>
                  <Grid item xs={12} lg={6} xl={2}>
                    <span style={{ fontSize: 14 }}>{x.username}</span>
                  </Grid>
                  <Grid item xs={12} lg={6} xl={2}>
                    <span style={{ fontSize: 14 }}>{x.ipClient}</span>
                  </Grid>
                  <Grid item xs={12} lg={6} xl={2}>
                    <span style={{ fontSize: 14 }}>{x.macAddress}</span>
                  </Grid>
                  <Grid item xs={12} lg={6} xl={2} />
                  <Grid item xs={12} lg={6} xl={1} />
                </>
              );
            })} */}
            <Grid item xs={12} lg={6} xl={9}></Grid>
            <Grid item xs={12} lg={6} xl={3}>
              <VuiButtonCustom
                title="Fechar"
                color="secondary"
                fontWeight="bold"
                icon="close"
                iconSide="left"
                onClick={() => {
                  onClose();
                }}
              />
            </Grid>
          </Grid>
        </>
      )}
    </VuiBox>
  );
}
